module.exports = __webpack_public_path__ + "img/4_03.275f61a1.png";